import { ICalendarOverride } from "../../domain/absences/ICalendarOverride";
import { IEmployeeAbsences } from "../../domain/absences/IEmployeeAbsenceInfo";
import { IEmployeeAbsenceRepository } from "../../domain/absences/IEmployeeAbsenceRepository";
import { ICalendar } from "../../domain/calendars/ICalendar";

import { isoDateString } from "../../helpers/dateHelpers";
import { restApiHelper } from "../helpers/RestApiHelper";
import { mapEmployeeAbsenceInfo, mapEmployeeAbsences } from "./Mappers/mapEmployeeAbsenceInfo";

export class EmployeeAbsenceRepository implements IEmployeeAbsenceRepository {
    async getAbsenceForDay(date: Date, isChanged: boolean): Promise<IEmployeeAbsences> {
        const response = await restApiHelper.get(`api/day/${isoDateString(date)}`, { isChanged });
        return mapEmployeeAbsences(response.body);
    }
    async getAbsenceForMonth(date: Date): Promise<ICalendar[]> {
        const absenceForMonth = await restApiHelper.getData(`api/month/${isoDateString(date)}`, {});
        return absenceForMonth.map(mapEmployeeAbsenceInfo);
    }
    async getAbsence(dateFrom: Date, dateTo: Date): Promise<ICalendar[]> {
        // const absenceForDay = await restApiHelper.getData("api/month");
        // return absenceForDay.map(this._mapEmployeeAbsenceInfo);
        return Promise.resolve([]);
    }

    async setInMeeting(minutesInMeeting: number): Promise<boolean> {
        return await restApiHelper.post(`api/meeting/in/` + minutesInMeeting);
    }

    async setMeetingOver() {
        return await restApiHelper.post(`api/meeting/over`);
    }

    async saveEvent(event: ICalendarOverride): Promise<any> {
        return await restApiHelper.post(`api/override/new`, event);
    }
    async deleteEvent(eventOid: string): Promise<any> {
        return await restApiHelper.delete(`api/override/${eventOid}`);
    }
}
